import React, {useState, useEffect, createRef} from 'react';
import {StyleSheet, View, Text, StyleProp, ViewStyle} from 'react-native';
import {colors} from 'src/assets';

export type TableRowProps = {
  containerStyle?: StyleProp<ViewStyle>;
  text: string;
  detail: string;
  sufix: string;
};

export const TableRow: React.FC<TableRowProps> = ({
  containerStyle,
  text,
  detail,
  sufix,
}) => {
  return (
    <View style={[styles.container, containerStyle]}>
      <Text style={styles.text}>{text}</Text>
      <Text style={styles.detail}>
        <Text style={styles.detailBold}>{detail}</Text>
        {sufix}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.chokuGray11,
    paddingHorizontal: 16,
    paddingVertical: 8,
    flexDirection: 'row',
  },
  text: {
    color: colors.chokyGray10,
    fontSize: 12,
    width: 120,
  },
  detail: {
    color: colors.chokyGray10,
    fontSize: 12,
  },
  detailBold: {
    color: colors.chokyGray10,
    fontSize: 14,
    fontWeight: 'bold',
  },
});
